const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/members/onboarding/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/members/onboarding/$")({
  beforeLoad: ({
    location
  }) => {
    redirect({
      // Preserve the legacy splat suffix, query, and hash (for example,
      // /members/onboarding/access) when redirecting into the new namespace.
      href: location.href.replace("/members/onboarding", "/settings/members/onboarding"),
      replace: true,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});